/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {useAuth} from '../../../../app/modules/auth'
import {Languages} from './Languages'
import {toAbsoluteUrl} from '../../../helpers'
import { getUserRolesList, updateUser } from '../../../../app/modules/users/users-list/core/_requests'
import { toast } from 'react-toastify'
import { useListView } from '../../../../app/modules/amazon-account/amazon-accounts-list/core/ListViewProvider'
import { useThemeMode } from '../theme-mode/ThemeModeProvider'
import { BUYER_VIEW_PERMISSION, exitBuyerView, isBuyerView } from '../../../../app/modules/auth/core/BuyerView'
import { BuyerViewModal } from '../../../../app/modules/auth/components/BuyerViewControls'
import { TruncatedText } from '../../../../ui/Tooltip'

const API_URL:any = process.env.REACT_APP_KT_API_URL
const BASE_URL = API_URL.replace(/\/api$/, '')
type Props = {
  // 'sidebar' renders the dropdown as a rounded card anchored under the sidebar profile card
  variant?: 'header' | 'sidebar'
}

const HeaderUserMenu: FC<Props> = ({variant = 'header'}) => {
  const isSidebar = variant === 'sidebar'
  const {currentUser, logout,setCurrentUser} = useAuth()
  // Switch off = Admin view, on = read-only view as a chosen buyer (real buyer token from the API)
  const inBuyerView = isBuyerView()
  const [buyerPickerOpen, setBuyerPickerOpen] = useState(false)
  const canViewAsBuyer =
    (currentUser?.user_type?.id === 1 || currentUser?.user_type?.id === 2) &&
    !!currentUser?.hasPermission(BUYER_VIEW_PERMISSION)
  // const [roles,setRoles]=useState<any>(null);
  // const [getLocalStorage,setGetLocalStorage]=useState<any>("");
  // const [check, setCheck]=useState(false)
  // const {mode} = useThemeMode()


 
        // const handleChange = async (event: React.ChangeEvent<HTMLSelectElement>) => {
        //   const selectedRoleName = event.target.value;
        //   const selectedRole = roles.find(role => role.name === selectedRoleName);

        //   if (!selectedRole) return;

        //   const updatedValues = {
        //     ...currentUser,
        //     roles: [{ ...selectedRole }]
        //   };

        //   try {
        //     await updateUser(updatedValues);
        //     toast.success("User is updated successfully");
        //      setCheck(!check)
        //     const updatedUserPermission = currentUser && {
        //       ...currentUser,
        //       roles: currentUser.id === updatedValues.id
        //         ? updatedValues.roles
        //         : currentUser.roles,
        //     };
        //     localStorage.setItem("current_user_id", JSON.stringify(false))
        //     setCurrentUser(() => updatedUserPermission);
        //   } catch (error) {
        //     console.error(error);
        //   }
        // };



    // async function fetchUserRoles() {
    //   try {
    //     const roles = await getUserRolesList();
    //     // console.log('User roles:', roles);
    //   setRoles(roles?.data?.filter((role:any) => role?.name !== "Buyer"));
    //   } catch (error) {
    //     console.error('Error fetching user roles:', error);
    //   }
    // }

    // useEffect(()=>{
    // fetchUserRoles()
    // },[])

    //   useEffect(()=>{
    //   setGetLocalStorage(JSON.parse(localStorage.getItem("current_user_id") || '""'));
    //     },[check,localStorage.getItem("current_user_id")])

        // console.log("currentUserdsdsa",currentUser?.roles?.[0].id === 1 || currentUser?.roles?.[0].id === 2)

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-primary fw-bold pb-4 fs-6 w-250px'
      data-kt-menu='true'
      data-popper-placement='bottom-start'
      style={
        isSidebar
          ? {borderRadius: 16, overflow: 'hidden', boxShadow: '0 12px 32px rgba(0, 0, 0, 0.18)'}
          : undefined
      }
    >
      <div className='menu-item px-0' style={{background: 'var(--table-head-bg)'}}>
        <div className='menu-content d-flex align-items-center px-4 pt-3'>
          <div className='symbol symbol-50px me-5' style={{height:50, width:50}}>
            {/* <img alt='Logo' src={toAbsoluteUrl('/media/avatars/300-1.jpg')} /> */}
                 <img
                  style={{objectFit:"cover", height:"100%", width:"100%"}}
                  src= {currentUser?.profile_picture ? `${BASE_URL}/uploads/profile-pictures/${currentUser?.profile_picture}` : toAbsoluteUrl('/media/avatars/300-1.jpg')}
                  alt="Profile Picture"
                  className="avatar-img"
                />
          </div>

          <div className='d-flex flex-column' style={{maxWidth:180,minWidth:0}}>
            <div className='fw-bolder d-flex align-items-center fs-5' style={{textTransform:"capitalize"}}>
               {/* {currentUser?.fullName} */}
               <TruncatedText
                 text={[currentUser?.first_name, currentUser?.last_name].filter(Boolean).join(" ") || "User"}
               />
              {/* <span className='badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2'>Pro</span> */}
            </div>
              {/* <a href='#' className='fw-bold text-muted text-hover-primary fs-7' style={{cursor:"default"}} onClick={(e)=> e.preventDefault()}> */}
            <a href='#' className='fw-bold text-muted fs-7' style={{cursor:"default"}} onClick={(e)=> e.preventDefault()}>
              <TruncatedText text={currentUser?.email ?? ''} lines={2} style={{wordBreak: 'break-all'}} />
            </a>
          </div>
        </div>
      </div>

      <div className='separator mt-0 mb-0'></div>

      {/* <div className='menu-item px-3'>
        <Link to={'/account/overview'} className='menu-link px-5'>
          My Profile
        </Link>
      </div> */}

      {/*<div className='menu-item px-5'>*/}
      {/*  <a href='#' className='menu-link px-5'>*/}
      {/*    <span className='menu-text'>My Projects</span>*/}
      {/*    <span className='menu-badge'>*/}
      {/*      <span className='badge badge-light-danger badge-circle fw-bolder fs-7'>3</span>*/}
      {/*    </span>*/}
      {/*  </a>*/}
      {/*</div>*/}

      {/*<div*/}
      {/*  className='menu-item px-5'*/}
      {/*  data-kt-menu-trigger='hover'*/}
      {/*  data-kt-menu-placement='left-start'*/}
      {/*  data-kt-menu-flip='bottom'*/}
      {/*>*/}
      {/*  <a href='#' className='menu-link px-5'>*/}
      {/*    <span className='menu-title'>My Subscription</span>*/}
      {/*    <span className='menu-arrow'></span>*/}
      {/*  </a>*/}

      {/*  <div className='menu-sub menu-sub-dropdown w-175px py-4'>*/}
      {/*    <div className='menu-item px-3'>*/}
      {/*      <a href='#' className='menu-link px-5'>*/}
      {/*        Referrals*/}
      {/*      </a>*/}
      {/*    </div>*/}

      {/*    <div className='menu-item px-3'>*/}
      {/*      <a href='#' className='menu-link px-5'>*/}
      {/*        Billing*/}
      {/*      </a>*/}
      {/*    </div>*/}

      {/*    <div className='menu-item px-3'>*/}
      {/*      <a href='#' className='menu-link px-5'>*/}
      {/*        Payments*/}
      {/*      </a>*/}
      {/*    </div>*/}

      {/*    <div className='menu-item px-3'>*/}
      {/*      <a href='#' className='menu-link d-flex flex-stack px-5'>*/}
      {/*        Statements*/}
      {/*        <i*/}
      {/*          className='fas fa-exclamation-circle ms-2 fs-7'*/}
      {/*          data-bs-toggle='tooltip'*/}
      {/*          title='View your statements'*/}
      {/*        ></i>*/}
      {/*      </a>*/}
      {/*    </div>*/}

      {/*    <div className='separator my-2'></div>*/}

      {/*    <div className='menu-item px-3'>*/}
      {/*      <div className='menu-content px-3'>*/}
      {/*        <label className='form-check form-switch form-check-custom form-check-solid'>*/}
      {/*          <input*/}
      {/*            className='form-check-input w-30px h-20px'*/}
      {/*            type='checkbox'*/}
      {/*            value='1'*/}
      {/*            defaultChecked={true}*/}
      {/*            name='notifications'*/}
      {/*          />*/}
      {/*          <span className='form-check-label text-muted fs-7'>Notifications</span>*/}
      {/*        </label>*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}

      {/*<div className='menu-item px-5'>*/}
      {/*  <a href='#' className='menu-link px-5'>*/}
      {/*    My Statements*/}
      {/*  </a>*/}
      {/*</div>*/}

      <div className='separator mt-0 mb-0'></div>

      {/*<Languages />*/}

      <div className='menu-item px-3 my-1'>
        <Link to='/account/settings' className='menu-link px-5'>
          Account Settings
        </Link>
      </div>
      {inBuyerView || canViewAsBuyer ? (
        <div className='menu-item px-3 my-1'>
          <div className='menu-content d-flex align-items-center justify-content-between px-5'>
            <span className='fw-bold fs-6'>{inBuyerView ? 'Switch to Admin' : 'Switch to Buyer'}</span>
            <label className='form-check form-switch form-check-custom form-check-solid'>
              <input
                className='form-check-input w-40px h-20px cursor-pointer'
                type='checkbox'
                name='switch'
                checked={inBuyerView}
                onChange={(e) => {
                  if (e.target.checked) {
                    setBuyerPickerOpen(true)
                  } else {
                    exitBuyerView()
                  }
                }}
              />
            </label>
          </div>
        </div>
      ) : null}
      <BuyerViewModal show={buyerPickerOpen} onClose={() => setBuyerPickerOpen(false)} />
      {/* {
        getLocalStorage ? 
     <>
        <div className='separator my-2'></div>
     <div className='menu-item px-5 my-1'>
       <div className='d-flex justify-content-space-between align-items-center' style={{paddingLeft:16}}>
           <div className={`${mode === "dark" ? "cdcdde" :"#252f4a"}`}>Change Role</div> :
           <div>
          <div style={{ position: "relative", display: "inline-block", width: "92%" }}>
            <select
              name="role"
              value={currentUser?.roles?.[0]?.name || ""}
              onChange={handleChange}
              className="form-control form-control-solid cursor-pointer"
              style={{
                fontSize: "13.975px",
                padding: "6px",
                paddingRight: "16px",
                marginLeft: "6px",
                appearance: "none",
                WebkitAppearance: "none",
                MozAppearance: "none",
                backgroundColor: mode === "dark" ? "#1b1b29" : "#f1f1f2",
                backgroundImage: `url("data:image/svg+xml;utf8,<svg fill='gray' height='16' viewBox='0 0 24 24' width='16' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/></svg>")`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "right 4px center",
                backgroundSize: "16px"
              }}
              >
                {roles?.map((role) => (
                  <option key={role.id || role.value} value={role.value}>
                    {role.label || role.name}
                  </option>
                ))}
            </select>
            </div>
           </div>
         </div>
         </div>
          <div className='separator my-2'></div>
       </>
          :""
      } */}

      <div className='menu-item px-3'>
        <a onClick={()=>logout("true")} className='menu-link px-5'>
          Sign Out
        </a>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
